

<div class="d-flex flex-column position-relative prime-autocomplete form-input"  #mydiv> 
  <label  class="justify-content-start d-flex">{{label}}<span *ngIf="mandatory" class="text-danger">*</span></label>
  <div (focusout)="elementFocused()" [ngClass]="{
    'border-danger': isInerrorState
  }">
<p-autoComplete [appendTo]="'body'" placeholder="{{placeholder}}"   [(ngModel)]="defaultSelected" (onKeyUp)="onKeyUp($event)"(onDropdownClick)="onCompleteMethod($event)" styleClass="d-flex align-items-center  w-100  input-field"  [suggestions]="suggestionList"
    (ngModelChange)="selectedValues($event)" field="value" dataKey="value" [dropdown]="toShowDropDown">
    <ng-template let-item let-i="index" pTemplate="item">
      <div>
        <span *ngIf="item.key === 'custom' && !doesSearchKeyExists && currentKeyWord?.length > 0">{{mls.languageText.profile_detail_timeline_education.key1}} "</span>
        <span [innerHtml]="item.value | highlight: currentKeyWord">"</span>
        <span *ngIf="item.key === 'custom' && !doesSearchKeyExists && currentKeyWord?.length > 0">"</span>
      </div>
  </ng-template>
</p-autoComplete>
  </div>
</div>


